import ApiClient from './ApiClient';

class MetaCapiPixelsAPI extends ApiClient {
  constructor() {
    super('meta_capi_pixels', { accountScoped: true });
  }
}

export default new MetaCapiPixelsAPI();
